import { render, staticRenderFns } from "./Appoint.vue?vue&type=template&id=2b444a7a&scoped=true&"
import script from "./Appoint.vue?vue&type=script&lang=ts&"
export * from "./Appoint.vue?vue&type=script&lang=ts&"
import style0 from "./Appoint.vue?vue&type=style&index=0&id=2b444a7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b444a7a",
  null
  
)

export default component.exports